class FAQNavigation extends HTMLElement {
  constructor() {
    super();
    this.scrollTicking = false;
  }

  connectedCallback() {
    this.initFAQNavigation();
  }

  initFAQNavigation() {
    const navigationId = this.id;
    const navigation = this;
    
    if (!navigation) return;

    const tabs = navigation.querySelectorAll('[data-target]');
    
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const targetId = this.getAttribute('data-target');
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          tabs.forEach(t => t.classList.remove('active'));
          this.classList.add('active');
          
          const stickyNav = navigation.closest('.faq-navigation-section.sticky-nav');
          let offset = 20;
          
          if (stickyNav) {
            offset = stickyNav.offsetHeight + 20;
          }
          
          const header = document.querySelector('header, .header, .site-header');
          if (header) {
            offset += header.offsetHeight;
          }
          
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
          
          setTimeout(() => {
            const firstDetails = targetElement.querySelector('details');
            if (firstDetails && !firstDetails.open) {
              const summary = firstDetails.querySelector('summary');
              if (summary) summary.click();
            }
          }, 500);
        } else {
          console.warn('Target section with ID "' + targetId + '" not found. Please check the Section ID in your collapsible content section settings.');
        }
      });
    });
    
    if (tabs.length > 0) {
      tabs[0].classList.add('active');
    }
    
    if (navigation.hasAttribute('highlight-on-scroll')) {
      let ticking = false;
      
      window.addEventListener('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(function() {
            navigation.updateActiveTab(tabs);
            ticking = false;
          });
          ticking = true;
        }
      });
    }
  }

  updateActiveTab(tabs) {
    const scrollPos = window.scrollY + 200;
    
    tabs.forEach(tab => {
      const targetId = tab.getAttribute('data-target');
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        const sectionTop = targetElement.offsetTop;
        const sectionBottom = sectionTop + targetElement.offsetHeight;
        
        if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
          tabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
        }
      }
    });
  }
}

customElements.define('faq-navigation', FAQNavigation);